'use client'

import { Button } from '@/app/components/atoms/Button'
import { useOptionalPageAnalytics } from '@/app/context/analytics'
import { NO_APLICA } from '@/app/lib/analytics/constants'
import { slugify } from '@/app/lib/analytics/dataLayer'

import { VENUE_LOCATION_MODULE_NAME } from './constants'

interface TrackedMoreEventsButtonProps {
  readonly href: string
  readonly label: string
  readonly className?: string
}

/**
 * `TrackedMoreEventsButton` — CTA "Más eventos en este recinto" con tracking de
 * `click` (`Ubicación Detalles Producto.csv` → misma fila `content_link` que
 * `TrackedVenueLink`, aplicada aquí al botón en vez de al enlace de texto —
 * módulo transversal, mismo criterio).
 *
 * Client Component: igual que `TrackedVenueLink`, necesita
 * `useOptionalPageAnalytics` para el `onClick`, que `PerformanceVenue` (Server
 * Component) no puede definir por sí solo.
 */
export function TrackedMoreEventsButton({ href, label, className }: TrackedMoreEventsButtonProps) {
  const analytics = useOptionalPageAnalytics()

  function handleClick() {
    analytics?.trackClick({
      click_type: 'content_link',
      click_subtype: NO_APLICA,
      link_text: slugify(label),
      link_url: href,
      link_domain: NO_APLICA,
      module_name: VENUE_LOCATION_MODULE_NAME,
      module_type: NO_APLICA,
      nav_level: NO_APLICA,
      nav_path: NO_APLICA,
      action_detail: NO_APLICA,
      action_value: NO_APLICA,
      action_context: NO_APLICA,
    })
  }

  return (
    <Button href={href} variant="filled" size="m" stretch className={className} onClick={handleClick}>
      {label}
    </Button>
  )
}
